export type PSCSummary = {
    vessel_imo: number;
    vessel_name: string;
    vessel_type: string;
    num_inspections: number;
    num_deficiencies: number;
    num_detentions: number;
    deficiency_per_inspection: number;
    detention_rate: number;
    date: number;
    days_detained: number;
    detained: string;
    released: number;
}

export type PSCInspection = {
    vessel_imo: number;
    vessel_name: string;
    vessel_type: string; 
    date: number;
    days_detained: number;
    detained: string;
    expanded: string;
    follow_up: string;
    inspection_id: number;
    inspection_type: string;
    location: string;
    location_code: string;
    country: string;
    mou: string;
    number_of_deficiencies: number;
    released: number;
}

export type PSCDeficiency = {
    vessel_imo: number;
    vessel_name: string;
    vessel_type: string;
    deficiency_id: string;
    defect_code: string;
    defect_text: string;
    defective_item_code: string;
    detainable: boolean;
    is_accidental_damage: boolean;
    main_defect_text: string;
    nature_of_defect_code: string;
    nature_of_defect_decode: string;
    inspection_id: number | string;
    inspection_type: string | undefined;
    location: string | undefined;
    country: string | undefined;
    mou: string | undefined;
    date: number | undefined;
    
}

export enum PSCTabs {
    performance,
    inspections,
    deficiencies,   
}

export const PSCTimePeriod = [
    "last36Months",
    "last12Months",
]